import React, { useState, useEffect } from "react";

import * as Styles from "./historicoBody.styles";

interface Props {
  nomeStatusTarefa: string;
  nomeTipoTarefa: string;
  observacao: string;
  dataAtualizacao: string;
  resultado?: string;
}

const HistoricoTarefa: React.FC<Props> = ({
  nomeStatusTarefa,
  nomeTipoTarefa,
  observacao,
  dataAtualizacao,
  resultado,
}) => {
  const [bgStatus, setBgStatus] = useState<string>("#D5D5D5");
  const [txtStatus, setTxtStatus] = useState<string>("#333333");

  useEffect(() => {
    switch (nomeStatusTarefa) {
      case "Concluida":
        setBgStatus("#4CAF50");
        setTxtStatus("#ffffff");
        break;

      case "Atrasada":
        setBgStatus("#F43636");
        setTxtStatus("#ffffff");
        break;

      case "Em Aberto":
        setBgStatus("#D5D5D5");
        setTxtStatus("#333333");
        break;

      default:
        setBgStatus("#D5D5D5");
        setTxtStatus("#333333");
        break;
    }
  });
  return (
    <>
      <Styles.BodyTarefas>
        <Styles.Text>Tipo: {nomeTipoTarefa}</Styles.Text>
        <Styles.Text>Data da tarefa: {dataAtualizacao}</Styles.Text>
        {observacao && <Styles.Text>Descrição: {observacao}</Styles.Text>}
        {nomeStatusTarefa === "Concluida" ? (
          <Styles.Text>Resultado: {resultado || "--"}</Styles.Text>
        ) : (
          <></>
        )}

        <Styles.StatusTag
          style={{
            backgroundColor: bgStatus,
          }}
        >
          <Styles.TagText
            style={{
              color: txtStatus,
            }}
          >
            {nomeStatusTarefa}
          </Styles.TagText>
        </Styles.StatusTag>
      </Styles.BodyTarefas>
    </>
  );
};

export default HistoricoTarefa;
